module.exports = __webpack_public_path__ + "static/media/326656_home_icon (4).41a3ea22.svg";